import React from "react"
import styled from "styled-components"
import { Theme } from "@pga/pga-component-library"
import { formatDate } from "../../utils/prospect"
import {
  isDeniedPtmApplication,
  mapPtmApplicationStatus,
} from "../../utils/prospect/ptmApplicationStatus"
import { flags, useFeatureFlags } from "../../lib/feature-flags"
import ApplicationDenialMessage from "./ApplicationDenialMessage"

const ApplicationStatusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  margin-top: 4px;
  justify-content: ${props => props.$centered && "center"};
`

const ApplicationStatusLabel = styled.span`
  font-family: ${Theme.fonts.Montserrat};
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
`

const ApplicationStatusText = styled.span`
  font-family: ${Theme.fonts.Montserrat};
  color: ${props => props.color || Theme.colors.darkGrey};
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
`

const ApplicationStatusDate = styled.span`
  font-family: ${Theme.fonts.Montserrat};
  color: ${Theme.colors.darkGrey};
  font-weight: 600;
  font-size: 13px;
`

const TYPE_LABELS = {
  associate: "Associate status:",
  affiliate: "Affiliate status:",
}

const PtmApplicationStatus = ({
  applicationId,
  status,
  registrationStatus,
  date,
  applicationType,
  centered,
}) => {
  const [denialMessageEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_APPLICATIONS_DENIAL_MESSAGE]) ?? []
  const statusDisplay = mapPtmApplicationStatus(status, registrationStatus)
  if (!statusDisplay) return null
  const formattedDate = formatDate(date)
  const label =
    TYPE_LABELS[String(applicationType || "").toLowerCase()] || "Status:"

  return (
    <ApplicationStatusWrapper
      data-testid="ptm-application-status"
      $centered={centered}
    >
      <ApplicationStatusLabel>{label}</ApplicationStatusLabel>
      <ApplicationStatusText color={statusDisplay.color}>
        {statusDisplay.text}
      </ApplicationStatusText>
      {formattedDate ? (
        <ApplicationStatusDate>| {formattedDate}</ApplicationStatusDate>
      ) : null}
      {denialMessageEnabled &&
      applicationId &&
      isDeniedPtmApplication(status) ? (
        <ApplicationDenialMessage
          applicationId={applicationId}
          applicationType={applicationType}
        />
      ) : null}
    </ApplicationStatusWrapper>
  )
}

export default PtmApplicationStatus
